// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loginCenterBackground {
    display: flex;
    flex-direction: column;
    justify-content:center;
    align-items: center;
    height: 100vh;
    width: 100%;
}
.AppSTitleName {
    color: white;
    font-family: var(--googleFont);
    font-weight: "bold";
    font-size: 50px;
}

.AppSTitleName2 {
    color: var(--HighlightBlue);
    font-family: var(--googleFont);
}


`, "",{"version":3,"sources":["webpack://./src/components/LoggedIn/login.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,WAAW;AACf;AACA;IACI,YAAY;IACZ,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,8BAA8B;AAClC","sourcesContent":[".loginCenterBackground {\n    display: flex;\n    flex-direction: column;\n    justify-content:center;\n    align-items: center;\n    height: 100vh;\n    width: 100%;\n}\n.AppSTitleName {\n    color: white;\n    font-family: var(--googleFont);\n    font-weight: \"bold\";\n    font-size: 50px;\n}\n\n.AppSTitleName2 {\n    color: var(--HighlightBlue);\n    font-family: var(--googleFont);\n}\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
